import { Center, Loader } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "@/components/admin/header/PageHeader";
import TagEditForm from "@/components/admin/tag/TagEditForm";
import { routes } from "@/configs/router.config/routes";
import { useTags } from "@/hooks/useTags";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { TagService } from "@/services/tag/tag.service";
import { showError, showSuccess } from "@/utils/notification";

const TagEditPage: React.FC = () => {
  const { t } = useTranslation("admin");
  const { tagId } = useParams();
  const navigate = useNavigate();
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { tags, isLoading, mutate } = useTags(sessionCurrentWorkspaceId);

  const tag = tags?.find((t) => t.id === tagId);

  if (!tagId) return <></>;

  const submit = async (_name: string, description: string) => {
    if (!tag) return;

    try {
      await TagService.updateTag(tag.id, { description });
      await mutate();
      showSuccess(t("tag.message.updateSuccess"));
      navigate(routes.tagList(sessionCurrentWorkspaceId));
    } catch (error) {
      console.error(error);
      showError(t("tag.message.updateError"));
    }
  };

  if (isLoading) {
    return (
      <>
        <PageHeader hasBack title={t("tag.editTitle")} />
        <Center h={100}>
          <Loader color="gray" size="sm" data-testid="loader" />
        </Center>
      </>
    );
  }

  return (
    <>
      <PageHeader hasBack title={t("tag.editTitle")} />

      <TagEditForm submit={submit} isLoading={isLoading} isUpdate tag={tag} />
    </>
  );
};

export default TagEditPage;
